import { render, staticRenderFns } from "./CreateLeads.vue?vue&type=template&id=5d4b53d2"
import script from "./CreateLeads.vue?vue&type=script&lang=js"
export * from "./CreateLeads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports